import { render, staticRenderFns } from "./GiftCardLanding.vue?vue&type=template&id=32cf3ca7"
import script from "./GiftCardLanding.vue?vue&type=script&lang=js"
export * from "./GiftCardLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports